import { render } from "./UserFace.vue?vue&type=template&id=5e67782a&ts=true"
import script from "./UserFace.vue?vue&type=script&lang=ts"
export * from "./UserFace.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__